import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'Brauche ich technisches Wissen für die Einrichtung?',
    answer: 'Nein. vox space wird vollständig von uns eingerichtet und konfiguriert. Sie erhalten ein fertiges System. Sie erhalten eine Rufnummer, auf die Sie jederzeit umleiten können.'
  }, {
    question: 'Was passiert nach der Testphase?',
    answer: 'Nach 4 Wochen wechseln Sie einfach in das passende Paket. Oder Sie kündigen, wenn es für Sie nicht passt.'
  }, {
    question: 'Ist vox space DSGVO-konform?',
    answer: 'Ja. Alle Daten werden auf Servern in Deutschland/EU verarbeitet. Die Lösung erfüllt die Anforderungen der DSGVO.'
  }, {
    question: 'Kann ich vox space auch außerhalb der Geschäftszeiten nutzen?',
    answer: 'Ja, genau dafür ist vox space gemacht. Der KI-Assistent ist rund um die Uhr erreichbar — auch nachts und am Wochenende. Sie entscheiden, wann Sie auf den Telefonassistenten umleiten.'
  }, {
    question: 'Welche Branchen nutzen vox space?',
    answer: 'vox space eignet sich besonders für Versicherungen, Handwerksbetriebe, Arztpraxen, Beratungen und Immobilienunternehmen — überall dort, wo Erreichbarkeit zählt.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-brand-gray" id="faq" data-id="element-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="text-center mb-12" data-id="element-22">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-brand-dark mb-4" data-id="element-23">
            Häufige Fragen
          </motion.h2>
        </div>

        <div className="space-y-4" data-id="element-24">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-25">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-26">
                <span className="font-semibold text-brand-dark pr-8" data-id="element-27">
                  {faq.question}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-accent flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-28" />
              </button>

              <AnimatePresence data-id="element-29">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-30">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-31">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}